import React, { useCallback } from "react";
import { connect } from "react-redux";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { UserDefinedLayout } from '../Layout';
import ReferencesTab from './ReferencesTab';

function UserDefinedTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const handleUserDefinedFormLoad = useCallback(() => {
        // Form load callback - can be used for any initialization if needed
    }, []);

    return (
        <div>
            <TabPanel showNavButtons={true} height={"auto"}>
                <TabItem title="User Defined">
                    <FormField
                        currrentUser={currentUser}
                        layoutId='4EA91CDE-B3B2-4C36-9966-C5C49E157185'
                        layoutName='WMChargeCodeUserDefinedForm'
                        defaultFormSchema={UserDefinedLayout}
                        formFields={props.formFields}
                        setformFields={props.setformFields}
                        handleFieldValueChange={props.handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={props.formRefs}
                        onFormLoad={handleUserDefinedFormLoad}
                    />
                </TabItem>
                <TabItem title="References">
                    <ReferencesTab 
                        formFields={props.formFields} 
                        setformFields={props.setformFields} 
                        formRefs={props.formRefs}
                        handleFieldChange={props.handleFieldChange}
                    />
                </TabItem>
            </TabPanel>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(UserDefinedTab);

